// Shared payment-reminder link builder for Finance (web Kanban + Telegram Mini App).

// Normalise a KZ phone number to international digits (no +).
export function normalizePhone(raw) {
  if (!raw) return '';
  let d = String(raw).replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('8')) d = '7' + d.slice(1);
  else if (d.length === 10) d = '7' + d;
  return d;
}

// Default reminder template (used if the card has no server-provided text).
export function defaultReminderText(card) {
  const amount = Number(card.amount || 0).toLocaleString('ru-RU');
  return `Здравствуйте! Напоминаем об оплате заказа №${card.order_number} на сумму ${amount} ₸. Спасибо!`;
}

// Returns { text, phone, waUrl, tgUrl }.
// waUrl → prefilled WhatsApp message (needs phone).
// tgUrl → Telegram share picker (works without a username).
export function buildReminder(card) {
  const text = card.reminder_text || defaultReminderText(card);
  const phone = normalizePhone(card.customer_phone);
  const waUrl = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent(text)}`
    : null;
  const tgUrl = `https://t.me/share/url?url=${encodeURIComponent(text)}`;
  return { text, phone, waUrl, tgUrl };
}


// Client-level reminder: aggregates total debt across all unpaid orders
// (used from the aging kanban / by-client view where a card represents a
// customer, not a single order).
export function buildClientReminder(client) {
  const amount = Number(client.total_owed || 0).toLocaleString('ru-RU');
  const orders = client.orders_count || (client.orders && client.orders.length) || 0;
  const orderWord = orders === 1 ? 'заказу' : (orders >= 2 && orders <= 4 ? 'заказам' : 'заказам');
  const name = client.customer_name && client.customer_name !== '—' ? `${client.customer_name}, ` : '';
  const text = `Здравствуйте! ${name}за вами задолженность ${amount} ₸ по ${orders} ${orderWord}. Просим оплатить. Спасибо!`;
  const phone = normalizePhone(client.customer_phone);
  const waUrl = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent(text)}`
    : null;
  const tgUrl = `https://t.me/share/url?url=${encodeURIComponent(text)}`;
  return { text, phone, waUrl, tgUrl };
}
